<template>
  <div class="raw-release-info">
    <!-- 无原始数据 -->


    <!-- 未释放 -->
<!--    <div v-else-if="status === 'NOT_RELEASED'" class="rd-state rd-state&#45;&#45;pending">-->
<!--      <div class="rd-header">-->
<!--        <el-tag type="warning" effect="dark"-->
<!--                style="text-align: center; width: 90px; line-height: 30px; height: 30px">未释放-->
<!--        </el-tag>-->
<!--      </div>-->
<!--    </div>-->

    <!-- 硬盘释放为主卡（合并组共用） -->
    <div v-if="status==='NO_DATA'" class="rd-state rd-state--none">
      <div class="rd-header">
        <el-tag type="info"
                style="width: 90px; padding: 0; text-align: center; line-height: 30px; height: 30px;background-color: #fdfdfe;color: #85888d;border: 1px solid #e0dfdf">无原始数据
        </el-tag>
      </div>
    </div>
    <raw-hdd-info
        v-else-if="status === 'HDD_RELEASED'"
        :isNeedMore="true"
        :select-detail="selectDetail"
        @lookSampleInfo="lookSampleInfo">
    </raw-hdd-info>
    <div v-else-if="status === 'NOT_RELEASED'&&!selectDetail?.rawInfo?.LINK?.exist">
        <el-tag type="info"
                style="width: 90px; padding: 0; text-align: center; line-height: 30px; height: 30px;background-color: #fdfdfe;color: #85888d;border: 1px solid #e0dfdf">NA
        </el-tag>
    </div>
    <project-raw-link-info
       v-else-if="status === 'LINK_RELEASED'||status === 'NOT_RELEASED'"
        :select-detail="selectDetail"
        @lookSampleInfo="lookSampleInfo"
        @downloadRawData="handleDownloadRawData">
    </project-raw-link-info>

    <!-- 释放详情弹框（独立组件，打开时重新请求，分 HDD/LINK） -->
    <raw-release-dialog
        :show-dialog.sync="dialogVisible"
        :select-detail="selectDetail">
    </raw-release-dialog>
  </div>
</template>

<script>
import RawHddInfo from './RawHddInfo.vue'
import RawLinkInfo from './RawLinkInfo.vue'
import RawReleaseDialog from './RawReleaseDialog.vue'
import {viewDetailIcon} from "@/utils/iconUtils";
import ProjectRawLinkInfo from "@/components/RawDataReleaseInfo/ProjectRawLinkInfo.vue";

export default {
  name: 'ProjectRawReleaseInfo',
  components: {ProjectRawLinkInfo, RawHddInfo, RawLinkInfo, RawReleaseDialog },
  props: {
    selectDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  computed: {
    // 合并组里的项目列表
    projects() {
      return Array.isArray(this.selectDetail?.projectInfoList) ? this.selectDetail.projectInfoList : []
    },
    // 原始数据状态：单项目取后端 rawDataStatus；合并组按组内项目汇总
    status() {
      const detail = this.selectDetail || {}
      if (detail.rawDataStatus) return detail.rawDataStatus
      if (this.projects.length) {
        const statuses = this.projects.map(p => this.projectStatus(p))
        if (statuses.every(s => s === 'NO_DATA')) return 'NO_DATA'
        if (statuses.every(s => s === 'NO_DATA' || s === 'NOT_RELEASED')) return 'NOT_RELEASED'
        return this.hasHdd ? 'HDD_RELEASED' : 'LINK_RELEASED'
      }
      return detail.isHdd ? 'HDD_RELEASED' : 'LINK_RELEASED'
    },
    // 组级是否有硬盘释放
    hasHdd() {
      if (this.projects.length) return this.projects.some(p => this.projectTypes(p).includes('HDD'))
      return this.selectDetail?.rawDataStatus === 'HDD_RELEASED' || !!this.selectDetail?.isHdd
    },
    // 组内有链接释放的项目（弹框表格数据）
    linkRows() {
      return this.projects.filter(p => this.projectTypes(p).includes('ONLINE'))
    }
  },
  methods: {
    viewDetailIcon() {
      return viewDetailIcon
    },
    // 单个项目释放类型：releaseTypes 优先，兼容旧数据 isHdd
    projectTypes(p) {
      if (Array.isArray(p?.releaseTypes)) return p.releaseTypes
      return p?.isHdd ? ['HDD'] : ['ONLINE']
    },
    // 单个项目状态：优先后端状态，否则按释放类型推断
    projectStatus(p) {
      if (p?.rawDataStatus) return p.rawDataStatus
      const types = this.projectTypes(p)
      if (types.includes('HDD')) return 'HDD_RELEASED'
      if (types.includes('ONLINE')) return 'LINK_RELEASED'
      return 'NOT_RELEASED'
    },
    lookSampleInfo(row) {
      this.$emit('lookSampleInfo', row)
    },
    // 继续向外传递，由页面（祖组件）调自己的下载原始数据
    handleDownloadRawData(row) {
      this.$emit('downloadRawData', row)
    }
  }
}
</script>

<style scoped>
.raw-release-info {
  font-size: 13px;
}

/* 「无原始数据 / 未释放」状态卡：沿用硬盘/网盘释放卡片的头部 + 字段行结构 */
.rd-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3px;
  padding-bottom: 3px;
}

.rd-body {
  line-height: 1.3;
}

.rd-row {
  display: flex;
  align-items: baseline;
  padding: 1px 0;
}

.rd-lbl {
  width: 4em;
  text-align: justify;
  text-align-last: justify;
  white-space: nowrap;
  flex-shrink: 0;
}

.rd-val {
  font-weight: 500;
  word-break: break-all;
}

/* 无原始数据：灰 */
.rd-state--none .rd-lbl,
.rd-state--none .rd-val {
  color: #909399;
}

/* 未释放：橙 */
.rd-state--pending .rd-lbl,
.rd-state--pending .rd-val {
  color: #c77c14;
}
</style>
